/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { Component } from 'react';
import { LinkAnchor } from '../../Links';

import styles from './notifications.module.scss';

class Notifications extends Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        const { homedashNotifications = [] } = this.props;
        return (
            <div className={`${styles.notifications}`}>
                {homedashNotifications && homedashNotifications.length > 0 && (
                    <React.Fragment>
                        {homedashNotifications.map((notification, i) => {
                            if (notification.is_active) {
                                return (
                                    <div className={`${styles.notification} sub-header`} key={`notification-${i}`}>
                                        <div style={{ backgroundColor: notification.backgroundcolor }} className={`d-flex align-items-center justify-content-center`}>
                                            <span style={{ color: notification.maintitlecolor }}>
                                                {(notification.hyperlinkwithcopy) ? (
                                                    <LinkAnchor href={notification.hyperlinkwithcopy} target="_blank" rel="noopener noreferrer">
                                                        <a style={{ color: notification.maintitlecolor }}>
                                                            {notification.copy}
                                                        </a>
                                                    </LinkAnchor>
                                                ) : (
                                                    <div className={styles.dangerouslySetNotification} dangerouslySetInnerHTML={{ __html: notification.copy }} />
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                );
                            }
                        })}
                    </React.Fragment>
                )}
            </div>
        );
    }
}

export default Notifications;
